import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icons/member.png'
import _imports_1 from '@/assets/img/cachet-signe.png'


const _hoisted_1 = { class: "navbar-content" }
const _hoisted_2 = { class: "navbar-nav" }
const _hoisted_3 = { class: "nav-item dropdown" }
const _hoisted_4 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdown"
}
const _hoisted_5 = { class: "d-flex flex-column align-items-center bcustom-alert-bottom px-5 py-1 border-bottom" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "tx-16 text-uppercase" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "tx-16" }
const _hoisted_10 = { class: "list-unstyled" }
const _hoisted_11 = { class: "dropdown-item py-2 cursor-pointer border-bottom" }
const _hoisted_12 = { class: "text-body ms-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.userUUID)
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: _normalizeClass(["navbar", _ctx.classes])
      }, [
        _createElementVNode("a", {
          class: "sidebar-toggler",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "bars",
            size: "lg",
            id: "messageDropdown",
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          })
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("a", {
                class: "nav-link dropdown-toggle",
                href: "#",
                id: "profileDropdown",
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, [
                _createElementVNode("img", {
                  class: "wd-30 ht-30 rounded-circle",
                  src: _imports_0,
                  alt: "profile"
                }),
                _createElementVNode("img", {
                  class: "wd-30 ht-30 rounded-circle",
                  src: _imports_1,
                  alt: "profile"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.user?.firstName || '') + " " + _toDisplayString(_ctx.user?.lastName || ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.user?.email || ''), 1)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: { name: 'profile', params: { userUUID: _ctx.userUUID } },
                      class: "bg-none text-body ms-0 d-block w-100"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "user-tie",
                          size: "lg",
                          class: "me-2 icon-md"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.profile')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", {
                    class: "dropdown-item py-2 cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("a", _hoisted_12, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "sign-out-alt",
                        size: "lg",
                        class: "me-2 icon-md"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.logout')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}